import React from 'react';
import { useSelector } from 'react-redux';
import { currentClientSelector } from '../../../AdviserArea/AdviserAreaSelector';
import { Tooltip } from '../../../CommonComponents/OPL/Tooltip/Tooltip';
import { ClientAccessData } from '../../ClientAccess.types';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { OnboardingWorkflow } from '../../../CommonSelectors/CommonArea.types';

interface Props extends ClientAccessData {
  isLoading: boolean;
  onClick(): void;
}

export const SaveAndPreview = ({ onClick, onboardingWorkflow, isLoading }: Props) => {
  const currentClient = useSelector(currentClientSelector);

  if (!currentClient?.CanPreviewClient) {
    return null;
  }

  const disabledReason =
    onboardingWorkflow === OnboardingWorkflow.AutoAccountWorkflow
      ? 'Preview Client Portal not available when the Automated Account Workflow is selected'
      : null;

  return (
    <Tooltip content={disabledReason} disabled={!disabledReason}>
      <span>
        <Button
          variant="secondary"
          onClick={onClick}
          disabled={!!disabledReason}
          isLoading={isLoading}
        >
          Save & Preview
        </Button>
      </span>
    </Tooltip>
  );
};
